import React from 'react';

import { EmptyLayout } from './';

export const DocLayout = ({ title, description, image, children, ...rest }) => (
  <EmptyLayout title={title} description={description} image={image}>
    {children}
  </EmptyLayout>
);
